<template>
  <div class="homework-empty_state">
    <img
      v-if="hasAccess"
      aria-hidden="true"
      alt=""
      src="~@/assets/images/thesis-pana.svg"
      class="homework-empty_state__icon"
    />
    <img
      v-else
      aria-hidden="true"
      alt=""
      src="~@/assets/images/work-time-pana.svg"
      class="homework-empty_state__icon"
    />
    <p class="homework-empty_state__description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'HomeworkEmptyState',
  props: {
    hasAccess: Boolean,
    // eslint-disable-next-line vue/require-prop-type-constructor
    default: false,
  },
  computed: {
    description() {
      return this.hasAccess ? 'Nie ma zadanej żadnej pracy domowej' : 'W tym miejscu za kilka dni pojawią się informacje o pracach domowych Twojego dziecka';
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-empty_state {
  @apply flex flex-col justify-center items-center px-4 py-10 bg-white;
  gap: 40px;

  @media screen and (min-width: 992px) {
    @apply px-8 py-12;
    gap: 32px;
  }

  &__icon {
    max-width: 200px;
    max-height: 200px;

    @media screen and (min-width: 992px) {
      max-width: 240px;
      max-height: 240px;
    }
  }

  &__description {
    color: #111724;
    text-align: center;
    font-family: "GT Walsheim Pro";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    max-width: 770px;

    @media screen and (min-width: 992px) {
      font-size: 36px;
      line-height: 40px;
      letter-spacing: -0.72px;
    }

  }
}
</style>
